/* 
  Asset: assets/infinite-scroll-gallery.js
  Rôle : piloter l’animation CSS de la piste en posant la variable --scroll-speed,
         appliquer direction/auto-rotate, et éviter les doubles initialisations.
*/
(() => {
  class InfiniteScrollGallery {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('[data-scroll-track]');
      if (!this.track) return;

      // Lire direction (sur track ou container) et l’imposer sur la track
      this.direction =
        this.track.dataset.direction ||
        this.container.dataset.direction ||
        'left';
      this.track.setAttribute('data-direction', this.direction);

      // Lire la vitesse sur le CONTAINER (fallback track) et poser la CSS var
      const rawSpeed =
        this.container.dataset.speed || this.track.dataset.speed || '40';
      this.speed = isNaN(parseFloat(rawSpeed)) ? 40 : parseFloat(rawSpeed);

      // data-auto-rotate => 'true'/'false' → boolean
      this.autoRotate =
        String(this.container.dataset.autoRotate).toLowerCase() === 'true';

      // binders
      this._onResize = this.handleResize.bind(this);
      this._onEnter = () => this.track.setAttribute('data-paused', 'true');
      this._onLeave = () => this.track.setAttribute('data-paused', 'false');

      this.init();
    }

    init() {
      this.setupAnimation();
      this.setupHoverPause();
      this.handleResize();
      // debounce léger sur resize
      let to;
      window.addEventListener('resize', () => {
        clearTimeout(to);
        to = setTimeout(this._onResize, 150);
      });
    }

    setupAnimation() {
      // Vitesse pour les keyframes CSS (ex: 40s)
      this.track.style.setProperty('--scroll-speed', `${this.speed}s`);

      // Démarrage/pause selon auto-rotate
      if (this.autoRotate) {
        this.track.setAttribute('data-paused', 'false');
      } else {
        this.track.setAttribute('data-paused', 'true');
      }
    }

    setupHoverPause() {
      // Pause au survol seulement si auto-rotate
      if (!this.autoRotate) return;
      this.track.addEventListener('mouseenter', this._onEnter);
      this.track.addEventListener('mouseleave', this._onLeave);
    }

    handleResize() {
      // Ici rien d’obligatoire : la largeur des items est pilotée en CSS
      // via --visible-count / --aspect-ratio. L’anim reste CSS-only.
      // Tu peux ajouter du calcul si nécessaire plus tard.
    }

    destroy() {
      window.removeEventListener('resize', this._onResize);
      this.track.removeEventListener('mouseenter', this._onEnter);
      this.track.removeEventListener('mouseleave', this._onLeave);
    }

    /* -------- Helpers statiques -------- */
    static initAll(root = document) {
      root
        .querySelectorAll('.infinite-scroll-container')
        .forEach((container) => {
          if (container.__isg) return; // évite les doubles instances
          container.__isg = new InfiniteScrollGallery(container);
        });
    }
  }

  // Initialisation standard
  document.addEventListener('DOMContentLoaded', () =>
    InfiniteScrollGallery.initAll()
  );

  // Theme Editor : re-init quand la section est rechargée/réordonnée
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) =>
      InfiniteScrollGallery.initAll(e.target)
    );
    document.addEventListener('shopify:section:reorder', () =>
      InfiniteScrollGallery.initAll(document)
    );

    // Pause lors de la sélection d’un block dans l’éditeur
    document.addEventListener('shopify:block:select', (e) => {
      const container = e.target.closest('.infinite-scroll-container');
      if (!container) return;
      const track = container.querySelector('[data-scroll-track]');
      if (track) track.setAttribute('data-paused', 'true');
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const container = e.target.closest('.infinite-scroll-container');
      if (!container) return;
      const track = container.querySelector('[data-scroll-track]');
      // On ne relance que si l’auto-rotate est activé
      const auto =
        String(container.dataset.autoRotate).toLowerCase() === 'true';
      if (track && auto) track.setAttribute('data-paused', 'false');
    });
  }
})();